// GROK-inspired Chat TLS Logo Component
// Simple circle with CT letters - minimal and clean like Grok with glassmorphism

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function GrokLogo({ size = 24, className = "" }: { size?: number; className?: string }) {
  const fontSize = Math.max(size * 0.45, 12);
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && theme === 'dark';
  
  return (
    <div 
      className={`relative flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Outer circle - glassmorphism effect */}
      <div 
        className={`absolute inset-0 rounded-full border ${isDark ? 'border-white/20' : 'border-gray-300/50'}`}
        style={{ 
          background: isDark ? 'rgba(0, 0, 0, 0.4)' : 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(20px) saturate(180%)',
          boxShadow: isDark 
            ? '0 0 0 1px rgba(255,255,255,0.1), 0 4px 6px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
            : '0 0 0 1px rgba(0,0,0,0.05), 0 4px 6px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.5)'
        }}
      />
      
      {/* CT text - centered in circle */}
      <div 
        className="absolute inset-0 flex items-center justify-center"
        style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          fontWeight: 600,
          letterSpacing: '-0.03em',
          color: isDark ? 'white' : '#111827',
          textShadow: isDark 
            ? '0 1px 2px rgba(0,0,0,0.5)' 
            : '0 1px 2px rgba(255,255,255,0.8)'
        }}
      >
        <span style={{ fontSize: `${fontSize}px`, lineHeight: 1 }}>
          CT
        </span>
      </div>
    </div>
  );
}
